import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Videojs from "../video-js";
import Image from "../../elements/image";
import BodyText from "../../elements/body-text";
import { apiAsia } from "../../utils/api-asia";
import UseQuery from "../../utils/useQuery";
import { RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { PrimaryButton, Icon } from "../../elements";
import { mobileIs } from "../../utils/siteUtils";
import Toast from "../../elements/toast";
import { gtag } from "../../utils"

import "./style.scss";
const UnSubscribeNew = props => {
  const { lang, fields, page } = props;
  let timer = null;
  const [isUnbind, setIsUnbind] = useState(false)
  const [toastShow, setToastShow] = useState(false)
  const [toastTip, setToastTip] = useState('')
  const [isBind, setIsBind] = useState(false)
  const { cancelTitle, cancelContent, cancelBtn, cancelBtnOther, resubscribeBtn, resubscribeTitle, resubscribeContent, resubscribeSuccessTitle, resubscribeSuccessContent, subscribedErrorTip, canceledErrorTip, defaultErrorTip, undefindErrorTip} = fields;
  useEffect(v=>{
    visit()
    getBindStatue()

  },[])
  const  getBindStatue = _ => {
    const query = UseQuery();
    if(query.email){
      apiAsia.form.check(null,{Email: query.email}).then(res => {
        if(!!res[1]){
          if(res[1].Data){
            setIsUnbind(true)
          }else{
            setIsUnbind(false)
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
    } 
  }
  const unbind = _ => {
    gtag('event', 'Component_info', {
      'component_name': 'UnSubscribeNew',
      'page_title': page?.name
    });
    const query = UseQuery();
    if(query.skey){
      apiAsia.form.unbind(null,{subscribeKey: query.skey}).then(res => {
        if(!!res[1] && res[1].Code == 200){
          setIsUnbind(true)
        }else{
          if(res[1].Code == '-102'){
            setToastTip(canceledErrorTip.value || defaultErrorTip.value || res[1].Message);
          } else if (res[1].Code == '-104'){
            setToastTip(undefindErrorTip.value || defaultErrorTip.value || res[1].Message);
          } else {
            setToastTip(defaultErrorTip.value || res[1].Message);
          }

          cleatTimeOutFun()
        }
      })
      .catch(err => {
        console.log(err);
        setToastTip(defaultErrorTip.value || err);
        cleatTimeOutFun()
      });
    } 
  }
  const bind = _ => {
    gtag('event', 'Component_info', {
      'component_name': 'UnSubscribeNew',
      'page_title': page?.name
    });
    const query = UseQuery();
    if(query.skey){
      apiAsia.form.bind(null,{subscribeKey: query.skey}).then(res => {
        if(!!res[1] && res[1].Code == 200){
          setIsBind(true)
        }else{
          if(res[1].Code == '-103'){
            setToastTip(subscribedErrorTip.value || defaultErrorTip.value || res[1].Message);
          } else if (res[1].Code == '-104'){
            setToastTip(undefindErrorTip.value || defaultErrorTip.value || res[1].Message);
          } else {
            setToastTip(defaultErrorTip.value || res[1].Message);
          }
          cleatTimeOutFun()
        }
      })
      .catch(err => {
        console.log(err);
        setToastTip(defaultErrorTip.value ||err);
        cleatTimeOutFun()
      });
    } 
  }
  const visit = _ => {
    const query = UseQuery();
    if(query.skey && query.act !== 'unsub'){
      apiAsia.form.visit({skey: query.skey})
    } 
  }
  const cleatTimeOutFun = _ => {
    setToastShow(true)
    clearTimeout(timer)
    timer = setTimeout(v=>{
      setToastShow(false)
    },2000)
  }
  
  return (
		<div className={classNames("UnSubscribeNew")} >
      { !isUnbind && !isBind && 
        <div className="UnSubscribeNew-cancel">
          <RichText className="title" field={cancelTitle}/>
          <RichText className="content" field={cancelContent} />
          <div className="btn">
            <div className="unbind" onClick={v=>unbind()}>
              <PrimaryButton {...cancelBtn?.fields} />
            </div>
            <PrimaryButton  {...cancelBtnOther?.fields} />
          </div>
        </div>
      }
      { isUnbind && !isBind  &&
        <div className="UnSubscribeNew-resubscribe">
          <RichText className="title" field={resubscribeTitle}/>
          <RichText className="content" field={resubscribeContent} />
          <div className="btn cancel" onClick={v=>bind()}>
              <PrimaryButton  {...resubscribeBtn?.fields} />
          </div>
        </div>
      }
      { isUnbind && isBind  &&
        <div className="UnSubscribeNew-success">
          <Icon name="Check" />
          <RichText className="title" field={resubscribeSuccessTitle}/>
          <RichText className="content" field={resubscribeSuccessContent} />
        </div>
      }
      
      { toastShow && 
        <Toast tip={toastTip} />
      }
		</div>
  );
};
export default UnSubscribeNew;
